var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-panel',{attrs:{"title":_vm.update ? 'Editar' : 'Nuevo' + ' seguimiento',"width":"medium"},on:{"closePanel":_vm.onCloseModal}},[_c('trackings-form',{attrs:{"current-opportunity":_vm.opportunity,"update":_vm.update,"customer":_vm.customer,"is-final":_vm.isFinal}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b2952af","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/tracings/tracings-create-view.vue
// module id = null
// module chunks = 